import React, { useContext } from "react";

import { useSnackBar } from "./useSnackBar";

interface SnackBarHelper {
  open: (message: string) => void;
  /**
   * @deprecated
   */
  openSnackBar: (message: string) => void;
}

const GlobalSnackbarContext = React.createContext<SnackBarHelper | null>(null);

export const GlobalSnackbarProvider: React.FC = ({ children }) => {
  const [Snackbar, helpers] = useSnackBar();

  return (
    <GlobalSnackbarContext.Provider value={helpers}>
      {children}
      <Snackbar />
    </GlobalSnackbarContext.Provider>
  );
};

/**
 * A snackbar rendered in App root, so that any component can open snackbar and the
 * snackbar stays even if the component is unmounted.
 */
function useGlobalSnackbar(): SnackBarHelper {
  const context = useContext(GlobalSnackbarContext);

  if (context === null) {
    throw new Error("No GlobalSnackBarContext provider found.");
  }

  return context;
}

export default useGlobalSnackbar;
